import Vue from "vue";
import Vuex from "vuex";

// Global vuex
import AppModule from "./app";
import user from "./user";
import hotel from "./hotel";
import currency from "./currency";
import department from "./department";
import announcement from "sentec-vues/modules/announcement/stores";

Vue.use(Vuex);

/**
 * Main Vuex Store
 */
const store = new Vuex.Store({
  modules: {
    app: AppModule,
    user,
    hotel,
    currency,
    department,
    announcement,
  },
});

export default store;